import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GoogleMapAddressComponent } from "../google-map-address/google-map-address.component";
import { GlobalVariableService } from "../../../common/variables/global-variable";
import {
  FormBuilder,
  FormGroup
} from '@angular/forms';
import { TranslateService } from "../../../common/variables/translate-service";
import { CountryData } from '../../api/CountryGetAll';
import { GlobalFunctionService } from '../../services/global-function.service';
import * as _ from 'lodash';

@Component({
  selector: 'sen-app-input-address',
  templateUrl: './input-address.component.html',
  styleUrls: ['./input-address.component.scss']
})
export class InputAddressComponent implements OnInit {
  @Input() address: any;
  @Input() reqHeight: boolean;
  @Input() parentForm: FormGroup;
  @Output() sendAddress = new EventEmitter<any>();
  @Output() terrainHeight = new EventEmitter<Event>();

  addressFromGoogleMap: any;
  countryArray: CountryData[];

  constructor(public dialog: MatDialog, public globalF: GlobalFunctionService, public formBuilder: FormBuilder, public global: GlobalVariableService, public translate: TranslateService) {
    this.globalF.getCountries().subscribe((data: CountryData[]) => {
      this.countryArray = data;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.address && changes.address.currentValue && changes.address.currentValue.street) {
      this.parentForm.get('full')?.setValue(`${this.address.street}, ${this.address.postalCode} ${this.address.location}, ${_.find(this.countryArray, { iso2: this.address.countryISO })?.name}`);
    } else {
      this.parentForm.get('full')?.setValue('');
    }
  }

  ngOnInit(): void { }

  openGMapAddress() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      address: this.address,
      reqHeight: this.reqHeight
    };
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.width = '80vw';
    dialogConfig.minHeight = '80vh';
    dialogConfig.position = { top: '3vh' }
    let dialogRef = this.dialog.open(GoogleMapAddressComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.addressFromGoogleMap = result;
        if (this.reqHeight) {
          this.terrainHeight.emit(result.tHeight)
        }
        this.parentForm.get('full')?.setValue(this.addressFromGoogleMap.full);
        this.sendAddress.emit(this.addressFromGoogleMap);
      }
      dialogRef.close();
    });
  }

}
